class Round_Date {
    static path = 'modifiers/round-date';

    constructor(mutator){
        this.bgcolor = '#ea93f8';
        this.title = 'Round Date';
        this.desc = 'Round a date to the start or end of the day/month/year, etc.';
        this.properties = {operation: '', unit: ''}

        this.addInput("Date", "date,datetime");
        this.addOutput("Rounded Date", "date,datetime");
        this.addWidget("combo","",'',{ property: "operation", values: ['Start of the', 'End of the'] } );
        this.addWidget("combo","",'',{ property: "unit", values: ['Year', 'Month', 'Day', 'Hour', 'Minute'] } );
    }

    getTitle() {
        if(this.properties.operation && this.properties.unit)
            return this.properties.operation + " " + this.properties.unit;
        else return this.title;
    }

}

module.exports = Round_Date
